import isString from 'lodash/isString';

export default (map, tier, shouldRemoveSources = true) => {
    if (!tier) {
        return;
    }

    const style = tier.getStyle();

    if (!style || isString(style)) {
        return;
    }

    const layers = style.layers;
    layers.forEach((layer) => {
        map.removeLayer(layer.id);
    });

    if (shouldRemoveSources) {
        const sources = style.sources;
        Object.keys(sources).forEach((sourceName) => {
            map.removeSource(sourceName);
        });
    }
};



// WEBPACK FOOTER //
// ./map/tier/styleUpdate/removeTier.js